import { useGlobalStore } from '@/stores/globalStore';
import { useOrderFormStore } from '@/stores/forms/orderFormStore';

function expressCheckoutEnabled() {
  const globalStore = useGlobalStore();
  const isEnabled = globalStore?.expressCheckoutEnabled ?? false;
  return isEnabled;
}

function isExpressCheckoutEnabledForMerchAndOrder() {
  const orderStore = useOrderFormStore();

  return (expressCheckoutEnabled() && orderStore.isAnExpressCheckoutOrder);
}

export { expressCheckoutEnabled, isExpressCheckoutEnabledForMerchAndOrder };
